export const customThemeVariables = {
  // --- Cores de fundo e texto por camada ---
  "--sjs-layer-1-background-500": "#FFFFFFFF",
  "--sjs-layer-1-background-400": "#E6EBF9FF",
  "--sjs-layer-1-foreground-100": "#122243FF",
  "--sjs-layer-1-foreground-50": "#0E205580",
  "--sjs-layer-1-foreground-75": "#2b97be",

  "--sjs-layer-2-background-500": "#F2F6FDFF",
  "--sjs-layer-2-background-400": "#DAE2F7FF",
  "--sjs-layer-2-foreground-100": "#273859FF",
  "--sjs-layer-2-foreground-75": "#2b97be",
  "--sjs-layer-2-foreground-50": "#26335880",

  "--sjs-layer-3-background-500": "#EAF0FBFF",
  "--sjs-layer-3-background-400": "#D3DDF5FF",
  "--sjs-layer-3-foreground-100": "#273859FF",
  "--sjs-layer-3-foreground-75": "#2b97be",
  "--sjs-layer-3-foreground-50": "#26335880",

  "--sjs-border-25": "#C2CEE6FF",
  "--sjs-border-10": "#CDD7EAFF",
  "--sjs-border-25-overlay": "#00000026",

  "--sjs-special-haze": "#2b97be40",
  "--sjs-special-glow": "#2b97be33",
  "--sjs-special-shadow": "#2b97be40",
  "--sjs-special-background": "#EAF0FBFF",

  // 🎯 Cor principal (permanece azul personalizada)
  "--sjs-primary-background-500": "#2b97be",
  "--sjs-primary-background-400": "#2b97be",
  "--sjs-primary-background-10": "#2b97be1A",
  "--sjs-primary-foreground-100": "#FFFFFFFF",
  "--sjs-primary-foreground-25": "#FFFFFF40",

  // ✅ Cor secundária (mantida como azul)
  "--sjs-secondary-background-500": "#2b97be",
  "--sjs-secondary-background-400": "#2b97be",
  "--sjs-secondary-background-25": "#2b97be40",
  "--sjs-secondary-background-10": "#2b97be1A",
  "--sjs-secondary-foreground-100": "#FFFFFFFF",
  "--sjs-secondary-forecolor-25": "#FFFFFF40",

  // 🔄 Cores semânticas também padronizadas com azul
  "--sjs-semantic-red-background-500": "#2b97be",
  "--sjs-semantic-red-background-10": "#2b97be1A",
  "--sjs-semantic-red-foreground-100": "#FFFFFFFF",

  "--sjs-semantic-green-background-500": "#2b97be",
  "--sjs-semantic-green-background-10": "#2b97be1A",
  "--sjs-semantic-green-foreground-100": "#FFFFFFFF",

  "--sjs-semantic-blue-background-500": "#2b97be",
  "--sjs-semantic-blue-background-10": "#2b97be1A",
  "--sjs-semantic-blue-foreground-100": "#FFFFFFFF",

  "--sjs-semantic-yellow-background-500": "#2b97be",
  "--sjs-semantic-yellow-background-10": "#2b97be1A",
  "--sjs-semantic-yellow-foreground-100": "#FFFFFFFF",

  "--sjs-semantic-white-background-500": "#FFFFFFFF",

  // 🎨 Códigos
  "--sjs-code-gray-700": "#B6B6B6FF",
  "--sjs-code-blue-500": "#2b97be",
  "--sjs-code-gray-300": "#505050FF",
  "--sjs-code-green-500": "#2b97be",
  "--sjs-code-red-500": "#2b97be",
  "--sjs-code-purple-500": "#2b97be",
  "--sjs-code-yellow-500": "#2b97be",
  "--sjs-code-gray-500": "#8A8A8AFF",

  // 🧩 Cores adicionais do themeJson (adaptadas)
  "--sjs-general-backcolor": "#FFFFFF",
  "--sjs-general-backcolor-dark": "#F8F8F8",
  "--sjs-general-backcolor-dim": "#DFE2E7",
  "--sjs-general-forecolor": "rgba(0, 0, 0, 0.91)",
  "--sjs-general-forecolor-light": "rgba(0, 0, 0, 0.45)",
  "--sjs-general-dim-forecolor": "rgba(0, 0, 0, 0.91)",
  "--sjs-general-dim-forecolor-light": "rgba(0, 0, 0, 0.45)",

  "--sjs-primary-backcolor": "#2b97be",
  "--sjs-primary-backcolor-light": "rgba(43, 151, 190, 0.1)",
  "--sjs-primary-backcolor-dark": "#247f9d",
  "--sjs-primary-forecolor": "#FFFFFF",
  "--sjs-primary-forecolor-light": "rgba(255, 255, 255, 0.25)",

  "--sjs-base-unit": "8px",
  "--sjs-corner-radius": "6px"
};

export const customTheme = {
  themeName: "customTheme",
  cssVariables: { ...customThemeVariables }
};